/**
 * @generated SignedSource<<07063ebf928634918780c5c075ff6666>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBreadcrumbs_build$data = {
  readonly branch: string;
  readonly changeIdInRepo: string;
  readonly id: string;
  readonly repository: {
    readonly id: string;
    readonly name: string;
    readonly owner: string;
    readonly platform: string;
  };
  readonly " $fragmentType": "AppBreadcrumbs_build";
};
export type AppBreadcrumbs_build$key = {
  readonly " $data"?: AppBreadcrumbs_build$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_build">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppBreadcrumbs_build",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "branch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "changeIdInRepo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "platform",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "owner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};
})();

(node as any).hash = "4cb7bb08d9c6e82856857d230d9b3536";

export default node;
